import { LookupDto } from '../../state/lookups/lookups-model';

export const INT32_MAX_VALUE: number = 2147483647;
export const TEN_DIGITIS_MAX_VALUE: number = 9999999999;
export const todayDate: Date = (() => {
  const date = new Date();
  date.setDate(date.getDate() - 1);
  date.setHours(0, 0, 0, 0);
  return date;
})();

export const PAGING_ROWS = 10;
export const MAX_UPLOAD_SIZE_MB = 100;
export const MAX_UPLOAD_SIZE_BYTES = MAX_UPLOAD_SIZE_MB * 1024 * 1024;

export const approvedTripStatus: LookupDto = {
  id: 6,
  displayValue: 'Approved',
  description: 'Approved',
};

export const approvedWithModificationsTripStatus: LookupDto = {
  id: 12,
  displayValue: 'Approved with Modifications',
  description: 'Approved with Modifications',
};
